/* ShivaRam — Favoritos (guardados solo en este navegador, sin datos personales) */
(function () {
  if (window.SRWishlist) return;

  var KEY = 'sr_wishlist_v1';
  var MAX = 200;
  var TEXTS = {
    es: { add: 'Añadir a favoritos', remove: 'Quitar de favoritos', added: 'Guardado en favoritos', removed: 'Eliminado de favoritos', view: 'Ver favoritos', unavailable: 'No se pueden guardar favoritos en este navegador' },
    en: { add: 'Add to favourites', remove: 'Remove from favourites', added: 'Saved to favourites', removed: 'Removed from favourites', view: 'View favourites', unavailable: 'Favourites cannot be saved in this browser' },
    fr: { add: 'Ajouter aux favoris', remove: 'Retirer des favoris', added: 'Ajouté aux favoris', removed: 'Retiré des favoris', view: 'Voir les favoris', unavailable: 'Impossible d’enregistrer des favoris dans ce navigateur' },
    de: { add: 'Zu Favoriten hinzufügen', remove: 'Aus Favoriten entfernen', added: 'In Favoriten gespeichert', removed: 'Aus Favoriten entfernt', view: 'Favoriten ansehen', unavailable: 'Favoriten können in diesem Browser nicht gespeichert werden' }
  };
  var lang = (document.documentElement.lang || 'es').slice(0, 2).toLowerCase();
  var t = TEXTS[lang] || TEXTS.es;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var PAGE_URL = root + 'pages/mis-favoritos';

  function read() {
    try {
      var v = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); return true; }
    catch (e) { return false; }
  }
  function indexOf(list, id) {
    for (var i = 0; i < list.length; i++) if (String(list[i].id) === String(id)) return i;
    return -1;
  }
  function has(id) { return indexOf(read(), id) > -1; }

  function emit(detail) {
    try { document.dispatchEvent(new CustomEvent('sr:wishlist-change', { detail: detail })); } catch (e) {}
  }

  function add(id, handle) {
    var list = read();
    if (indexOf(list, id) > -1) return true;
    list.unshift({ id: String(id), handle: handle || '', t: Date.now() });
    if (list.length > MAX) list.length = MAX;
    if (!write(list)) return false;
    syncAll(); emit({ id: String(id), added: true, count: list.length });
    return true;
  }
  function remove(id) {
    var list = read();
    var i = indexOf(list, id);
    if (i === -1) return true;
    list.splice(i, 1);
    if (!write(list)) return false;
    syncAll(); emit({ id: String(id), added: false, count: list.length });
    return true;
  }

  function update(btn) {
    var on = has(btn.getAttribute('data-product-id'));
    btn.classList.toggle('is-active', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? t.remove : t.add);
    btn.setAttribute('title', on ? t.remove : t.add);
    var txt = btn.querySelector('[data-sr-wl-text]');
    var label = on ? t.remove : t.add;
    if (txt && txt.textContent !== label) txt.textContent = label;
  }
  function syncAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-sr-wl]');
    for (var i = 0; i < nodes.length; i++) update(nodes[i]);
    var n = read().length;
    var counts = document.querySelectorAll('[data-sr-wl-count]');
    for (var j = 0; j < counts.length; j++) {
      var val = n > 99 ? '99+' : String(n);
      if (counts[j].textContent !== val) counts[j].textContent = val;
      if (counts[j].hidden !== (n === 0)) counts[j].hidden = n === 0;
    }
  }

  var toastEl, toastTimer;
  function toast(msg, withLink) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'sr-wl-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '';
    var span = document.createElement('span');
    span.textContent = msg;
    toastEl.appendChild(span);
    if (withLink) {
      var a = document.createElement('a');
      a.href = PAGE_URL;
      a.textContent = t.view;
      toastEl.appendChild(a);
    }
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3200);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-sr-wl]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = btn.getAttribute('data-product-id');
    var handle = btn.getAttribute('data-product-handle');
    var wasOn = has(id);
    var ok = wasOn ? remove(id) : add(id, handle);
    if (!ok) { toast(t.unavailable, false); return; }
    toast(wasOn ? t.removed : t.added, !wasOn);
  }, true);

  window.addEventListener('storage', function (e) { if (e.key === KEY) syncAll(); });

  var pending = false;
  function scheduleSync() {
    if (pending) return;
    pending = true;
    (window.requestAnimationFrame || setTimeout)(function () { pending = false; syncAll(); });
  }
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var k = 0; added && k < added.length; k++) {
          if (added[k].nodeType === 1) { scheduleSync(); return; }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  window.SRWishlist = { read: read, add: add, remove: remove, has: has, sync: syncAll, texts: t, pageUrl: PAGE_URL };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { syncAll(); });
  else syncAll();
})();
